<template>
  <div class="outerDiv">
    <div class="leftDiv">
      <div class="leftDiv-title">
        <span>{{this.$t('translateText.fbzy.fbdx')}}</span>
        <search :placeholder="$t('translateText.fbzy.ss')" @search="onSearch" />
      </div>
      <div class="leftDiv-radio">
        <a-radio-group v-model="issueTypeValue" @change="issueTypeChange">
          <a-radio :value="0">{{this.$t('translateText.fbzy.abjff')}}</a-radio>
          <a-radio :value="1">{{this.$t('translateText.fbzy.aryff')}}</a-radio>
        </a-radio-group>
      </div>
      <div class="leftDiv-table">
        <a-table
          ref="table"
          v-show="showClassList"
          :columns="ClassListColumns"
          :data-source="ClassList"
          :row-selection="{
            selectedRowKeys: selectedClassList,
            onChange: onClassChange,
          }"
          :pagination="false"

        >
        </a-table>
        <a-table
          ref="table"
          v-show="showUserList"
          :columns="UserListColumns"
          :data-source="UserList"
          :row-selection="{
            selectedRowKeys: selectedUserList,
            onChange: onUserChange,
          }"
          :pagination="false"

        >
        </a-table>
      </div>
    </div>
    <div class="rightDiv">
      <div class="rightDiv-title">
        <span>{{this.$t('translateText.fbzy.zdsj')}}:</span>
      </div>
      <div class="rightDiv-time">
        <a-date-picker
          id="startTime"
          v-model="startValue"
          :disabled-date="disabledStartDate"
          show-time
          format="YYYY-MM-DD HH:mm"
          :placeholder="$t('translateText.fbzy.kssj')"
          @openChange="handleStartOpenChange"
        />
        {{this.$t('translateText.fbzy.z')}}
        <a-date-picker
          id="endTime"
          v-model="endValue"
          :disabled-date="disabledEndDate"
          show-time
          format="YYYY-MM-DD HH:mm"
          :placeholder="$t('translateText.fbzy.jssj')"
          :open="endOpen"
          @openChange="handleEndOpenChange"
        />
      </div>
      <div class="rightDiv-title">
        <span>{{this.$t('translateText.fbzy.gjsz')}}:</span>
      </div>
      <div class="rightDiv-score">
        <div>
          <span>{{this.$t('translateText.fbzy.fzsz')}}</span>
        </div>
        <div class="rightDiv-score-right">
          <p>
            {{this.$t('translateText.fbzy.jgx')}}:<a-input
              type="text"
              @change="handlePassingScore"
              v-model="passingScore"
            />{{this.$t('translateText.fbzy.f')}}
          </p>
          <p>
            {{this.$t('translateText.fbzy.lhx')}}:<a-input
              type="text"
              @change="handleGoodScore"
              v-model="goodScore"
            />{{this.$t('translateText.fbzy.f')}}
          </p>
          <p>
            {{this.$t('translateText.fbzy.yxx')}}:<a-input
              type="text"
              @change="handleExcellentScore"
              v-model="excellentScore"
            />{{this.$t('translateText.fbzy.f')}}
          </p>
        </div>
      </div>
      <div class="rightDiv-view">
        <div>
          <span>{{this.$t('translateText.fbzy.cksz')}}</span>
        </div>
        <div class="rightDiv-view-right">
          <a-checkbox v-model="isViewScore">{{this.$t('translateText.fbzy.xsck')}}</a-checkbox>
        </div>
      </div>
      <div class="rightDiv-cheat">
        <div>
          <span>{{this.$t('translateText.fbzy.fzb')}}</span>
        </div>
        <div class="rightDiv-cheat-right">
          <a-checkbox v-model="isOutOrder">{{this.$t('translateText.fbzy.lx')}}</a-checkbox><br />
          <a-checkbox v-model="isStickUp">{{this.$t('translateText.fbzy.zt')}}</a-checkbox>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import search from "@/components/search"; //搜索组件
// import moment from "moment";
import {getAllCourseClass,getAllStudentByCourse} from "../../utils/api";
export default {
  props: {
    ClassListColumns: {
      type: Array,
      default: () => [],
    },
    // ClassList: {
    //   type: Array,
    //   default: () => [],
    // },
    UserListColumns: {
      type: Array,
      default: () => [],
    },
    // UserList: {
    //   type: Array,
    //   default: () => [],
    // },
  },
  data() {
    return {
      value:1,
      selectedRowKeys:"",
      searchName:"",//搜索关键字
      UserList:[],
      ClassList:[],
      showClassList: true,
      showUserList: false,
      issueTypeValue:0,
      startValue: '',
      endValue: null,
      endOpen: false,
      passingScore: 60,
      goodScore: 75,
      excellentScore: 90,
      isViewScore: true,
      isOutOrder: true,
      isStickUp: true,
      selectedClassList: [],
      selectedUserList: [],
      iseliminate:true,
      addExamDiv:"",
      releasetype:"",
    };
  },
  created(){
    if(this.issueTypeValue == 0){
        this.showClassList = true;
        this.showUserList = false;
        this.getclass()
        if(this.iseliminate){
          this.selectedUserList = []
        }
    }else if(this.issueTypeValue == 1){
        this.showClassList = false;
        this.showUserList = true;
        this.getstudent()
        if(this.iseliminate){
          this.selectedClassList = []
        }
    }
    this.addExamDiv = this.$parent.addExamDiv
  },
  methods: {
    //数组去重
    unique (arr) {
      return Array.from(new Set(arr))
    },
    //选择发布的用户或班级
    checkuser(val){
      
      this.selectedUserList = val
      // this.releasetype = type
      // this.$refs.table.selectedRowKeys = val
    },
    checkclass(val){
      this.selectedClassList = this.unique(val)
      // this.$refs.table.selectedRowKeys = val
      // this.releasetype = type
    },
    //搜索
    onSearch(val) {
      this.searchName=val;
      if(this.issueTypeValue==0){
        this.getclass();
      }else{
        this.getstudent();
      }
    },
    getclass(){
       let courseid = localStorage.getItem('courseId')
      getAllCourseClass({
        iCourseId:courseid,
        strClassName:this.searchName,
        dtStartTime:"",
        dtEndTime:"",
      }).then((response)=>{
        if(response.data.iCode == 0){
          
          response.data.objData.forEach(item => {
              this.$set(item,'key',item.iClassId)
          });
          this.ClassList = response.data.objData
        }else{
          return this.$message.error(response.data.strMessage);
        }
      })
    },
    getstudent(){
       let courseid = localStorage.getItem('courseId')
      getAllStudentByCourse({
        iCourseId:courseid,
        strRealName:this.searchName,
        iClassId:"0",
      }).then((response)=>{
        if(response.data.iCode == 0){
          response.data.objData.forEach(item => {
              this.$set(item,'key',item.iUserId)
          });
          this.UserList = response.data.objData
        }else{
          return this.$message.error(response.data.strMessage);
        }
      })
    },
    issueTypeChange(e) {
      if (e.target.value == 0) {
        this.showClassList = true;
        this.showUserList = false;
        this.getclass()
        if(this.iseliminate){
          this.selectedUserList = []
        }
        
      } else {
        this.showClassList = false;
        this.showUserList = true;
        this.getstudent()
        if(this.iseliminate){
          this.selectedClassList = []
        }
      }
    },
    //时间设置
    // disabledDate(current) {
    //   return current && current < moment().subtract(1, "days");
    // },
    disabledStartDate(startValue) {
      const endValue = this.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    },
    disabledEndDate(endValue) {
      const startValue = this.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return startValue.valueOf() >= endValue.valueOf();
    },
    handleStartOpenChange(open) {
      if (!open && this.addExamDiv ) {
        this.endOpen = true;
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open;
    },
    //分值设置
    handlePassingScore(e) {
      this.passingScore = e.target.value.replace(/[^\d]/g, "");
    },
    handleGoodScore(e) {
      this.goodScore = e.target.value.replace(/[^\d]/g, "");
    },
    handleExcellentScore(e) {
      this.excellentScore = e.target.value.replace(/[^\d]/g, "");
    },
    getSetData() {
      var startTime = document.querySelectorAll("#startTime")[0].firstChild
        .firstChild.value;
      var endTime = document.querySelectorAll("#endTime")[0].firstChild
        .firstChild.value;
      if (parseInt(this.passingScore) > 100) {
        return this.$message.error(this.$t('translateText.txxz.jgx'));
      }
      if (parseInt(this.goodScore) > 100) {
        return this.$message.error(this.$t('translateText.txxz.lhfsx'));
      }
      if (parseInt(this.excellentScore) > 100) {
        return this.$message.error(this.$t('translateText.txxz.yxfsx'));
      }
      if (startTime == "") {
        return this.$message.error(this.$t('translateText.txxz.kssj'));
      }
      if (endTime == "") {
        return this.$message.error(this.$t('translateText.txxz.jssj'));
      }
      var examinationRelease = {
        dtStartTime: startTime,
        dtEndTime: endTime,
        iPassingScore: parseInt(this.passingScore),
        iGoodScore: parseInt(this.goodScore),
        iExcellentScore: parseInt(this.excellentScore),
        ddIsStickUp: {
          iNumber: this.isStickUp ? 1 : 2,
        },
        ddIsOutOrder: {
          iNumber: this.isOutOrder ? 1 : 2,
        },
        ddIsViewScore: {
          iNumber: this.isViewScore ? 1 : 2,
        },
      };
      this.$emit("getExaminationRelease", examinationRelease);
    },
    //获取选中的用户或班级
    onClassChange(selectedRowKeys) {
      this.selectedClassList = selectedRowKeys;
      this.$emit("getReceiveList", selectedRowKeys, this.issueTypeValue);
    },
    onUserChange(selectedRowKeys) {
      this.selectedUserList = selectedRowKeys;
      this.$emit("getReceiveList", selectedRowKeys, this.issueTypeValue);
    },
    clear() {
      this.selectedClassList = [];
      this.selectedUserList = [];
    },
  },
  components: {
    search,
  },
  computed: {},
  watch:{
    startValue(){
      sessionStorage.setItem("startValuee",this.startValue)
    },
    endValue(){
      sessionStorage.setItem("endValuee",this.endValue)
    },
  }
};

</script>
<style lang="stylus" scoped>
.outerDiv {
  height: 340px;
  width: 100%;
  margin-top: 30px;
}

.leftDiv {
  float: left;
  border: solid 1px #C2C2C2;
  width: 40%;
}

.leftDiv-title {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  background-color: #F4F4F4;
  color: #414141;
}

&/deep/.leftDiv-title .search {
  width: 120px;
  float: right;
}

&/deep/.leftDiv-title .ant-input {
  height: 26px;
  line-height: 26px;
  font-size: 13px;
  top: 7px;
}

&/deep/.leftDiv-title .ant-input-suffix {
  top: 22px;
  right: 4px;
}

.leftDiv-radio {
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
}

&/deep/.ant-radio-checked .ant-radio-inner {
  border-color: #2EADB5;
}

&/deep/.ant-radio-inner::after {
  background-color: #2EADB5;
}

.leftDiv-table {
  height: 260px;
  overflow: auto;
  margin: 0 5px;
}

&/deep/ .ant-table-thead > tr > th {
  padding: 10px 10px;
  background-color: #fff;
}

&/deep/ .ant-table-tbody > tr > td {
  padding: 10px 10px;
}

.rightDiv {
  float: left;
  width: 60%;
  padding-left: 20px;
}

.rightDiv-title {
  line-height: 30px;
  font-size: 16px;
}

.rightDiv-time {
  margin-bottom: 10px;
}

&/deep/.rightDiv-time .ant-calendar-picker {
  min-width: 0 !important;
  width: 46%;
}

.rightDiv-score {
  height: 110px;
}

.rightDiv-score div {
  float: left;
  line-height: 30px;
}

.rightDiv-score .rightDiv-score-right {
  margin-left: 42px;
  color: #555555;
  line-height: 36px;
}

.rightDiv-score input {
  height: 25px;
  width: 60px;
  margin: 0 5px;
  border: 1px solid #888888;
  text-align: center;
}

.rightDiv-view {
  margin-top: 10px;
  height: 25px;
}

.rightDiv-view div {
  float: left;
  line-height: 30px;
}

.rightDiv-view .rightDiv-view-right {
  margin-left: 44px;
  color: #555555;
}

&/deep/.ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #2EADB5;
}

&/deep/.ant-checkbox-checked .ant-checkbox-inner {
  background-color: #2EADB5;
  border-color: #2EADB5;
}

&/deep/.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: #2EADB5;
}

.rightDiv-cheat {
  margin-top: 10px;
}

.rightDiv-cheat div {
  float: left;
  line-height: 30px;
}

.rightDiv-cheat .rightDiv-cheat-right {
  margin-left: 30px;
  color: #555555;
}
</style>